import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UntypedFormGroup } from '@angular/forms';
import { ChangePasswordResponse } from './change-password.models';
import { CHANGE_PASSWORD } from '../../http/base-http.service';
import { BaseUsermgrService } from '../../http/base-usermgr.service';
import { CookieService } from 'ngx-cookie-service';
import { HOST_NAME } from '../../../global.tokens';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService extends BaseUsermgrService {

  constructor(http:HttpClient,cookie:CookieService,@Inject(LOCALE_ID) public locale: string, @Inject(HOST_NAME) public hostName) {
    super(http,cookie,locale,hostName);
   }

   requestChangePassword (changePasswordForm: UntypedFormGroup): Observable<ChangePasswordResponse> {
    return super.postRequest<ChangePasswordResponse>(CHANGE_PASSWORD,changePasswordForm)
    .pipe(
      catchError(this.handleError)
    );
  }
}
